import { DispenseIntervalDialog } from '@/components/products/refill/DispenseIntervalDialog';
import { formatDateForDisplay } from '@/pages/umeds/order-medication/util';
import { Alert, AlertTitle, Typography, ViewObserver } from '@montugroup/design-system';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import LockClock from '@mui/icons-material/LockClock';
import { useState } from 'react';
import type { OrderHistoryIntervalDetails } from './OrderHistoryCard';
import { OrderDispenseIntervalContainer, StyledLink } from './OrderHistoryCard.styles';

type OrderHistoryDispenseIntervalAlertProps = {
  intervalDetails?: OrderHistoryIntervalDetails | null;
  orderNumber?: string;
};

export const OrderHistoryDispenseIntervalAlert = (props: OrderHistoryDispenseIntervalAlertProps) => {
  const { intervalDetails, orderNumber } = props;
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleLearnMoreClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <ViewObserver id={`order-history-interval-time-alert-${orderNumber ?? ''}`}>
      <OrderDispenseIntervalContainer data-dd-privacy="allow">
        <Alert severity="info" sx={{ width: '100%' }} icon={<LockClock />}>
          <AlertTitle sx={{ fontWeight: 'bold' }}>The order is pending</AlertTitle>
          <Typography variant="body2" data-chromatic="ignore">
            This order contains medication in dispense interval. We will process it on or after{' '}
            <strong>
              {intervalDetails &&
                intervalDetails.estimatedNextProcessDate &&
                formatDateForDisplay(intervalDetails.estimatedNextProcessDate)}
            </strong>
            .
          </Typography>
          <StyledLink
            variant="body2"
            fontWeight="fontWeightMedium"
            onClick={handleLearnMoreClick}
            id={`order-history-interval-learn-more-${orderNumber}`}
          >
            Learn more about Dispense Interval <InfoOutlined fontSize="small" sx={{ ml: 0.5 }} />
          </StyledLink>
        </Alert>
      </OrderDispenseIntervalContainer>
      <DispenseIntervalDialog dialogOpen={dialogOpen} handleCloseDialog={handleCloseDialog} />
    </ViewObserver>
  );
};
